import { EmailIcon } from "@chakra-ui/icons";
import {
  Box,
  Text,
  Input,
  Button,
  FormControl,
  FormLabel,
  InputGroup,
  InputLeftElement,
  useToast,
  Link
} from "@chakra-ui/react";
import React from "react";
import NextLink from "next/link";
import Header from "app/components/Header";
import { SubmitHandler, useForm } from "react-hook-form";
import axios from "axios";
import { useRouter } from "next/router";

const ForgotPasswordPage: React.FC = () => {
  const router = useRouter();
  const toast = useToast();
  const { register, handleSubmit } = useForm();
  const [error, setError] = React.useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(true);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const onSubmit: SubmitHandler<{ email: string }> = async ({ email }) => {
    try {
      setIsLoading(true);
      const response = await axios.post(`/api/forgot-password`, { email });

      if (response) {
        router.push("/auth/forgot-password/success");
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
    }
  };

  return (
    <>
      <Header />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          bg="#E5E5E5"
          h="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDir="column"
          mt={10}
        >
          <Box
            bg="white"
            borderRadius="md"
            w={{ base: "75%", sm: "66%", md: "66%", lg: "33%" }}
            h="384px"
            textAlign="center"
            display="flex"
            justifyContent="space-around"
            flexDir="column"
            p={10}
          >
            <Text fontSize="2xl" fontWeight="bold">
              Forgot Password
            </Text>
            <Text textColor="gray.500">
              Dont worry, enter your registered email account below. Well send
              instructions to your email right away
            </Text>
            <Box display="flex" flexDir="column">
              <Box>
                <FormControl>
                  <FormLabel
                    htmlFor="email"
                    fontWeight="semibold"
                    fontSize="sm"
                  >
                    Email
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none">
                      <EmailIcon />
                    </InputLeftElement>

                    <Input
                      {...register("email", { required: true })}
                      type="email"
                      onChange={e =>
                        e.target.value === ""
                          ? setIsSubmitting(true)
                          : setIsSubmitting(false)
                      }
                      placeholder="Ex: admin@qore.com"
                      borderColor=" gray.300"
                    />
                  </InputGroup>
                  {error && (
                    <Text color="red.400" textAlign="left" fontSize="sm" my={2}>
                      Seems the email you entered has not been registered. Try
                      again with email you registered.
                    </Text>
                  )}
                </FormControl>
              </Box>
            </Box>
            <Button
              type="submit"
              colorScheme="messenger"
              disabled={isSubmitting || isLoading}
              isLoading={isLoading}
              spinnerPlacement="start"
              loadingText="Sending link"
            >
              Send link to reset password
            </Button>
            <NextLink href="/auth/login" passHref>
              <Text color="#0065FF" cursor="pointer" fontWeight="semibold">
                Back to Login
              </Text>
            </NextLink>
          </Box>
          <Text fontSize="sm" mt={10}>
            © Qore, All rights reserved
          </Text>
        </Box>
      </form>
    </>
  );
};

export default ForgotPasswordPage;
